import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-shell {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

.auth-transition {
  position: absolute;
  inset: 0;
  background: #ffffff;
  opacity: 0;
  pointer-events: none;
  z-index: 8;
  transition: opacity 0.42s ease;
}

.auth-transition--active {
  opacity: 1;
}

.auth-shell__inner {
  width: 100%;
  min-height: 100dvh;
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  padding: 32px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: translateY(18px) scale(0.985);
  pointer-events: none;
  transition: opacity 0.42s ease, transform 0.46s ease;
  z-index: 4;
}

.auth-shell__inner--form {
  transform: translateY(24px) scale(0.98);
}

.auth-shell__inner--active {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.auth-hero {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0;
}

.auth-hero__trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.auth-hero__trigger:hover {
  transform: translateY(-2px);
}

.auth-hero__trigger:focus-visible {
  outline: 2px solid rgba(51, 65, 85, 0.45);
  outline-offset: 8px;
}

.auth-hero__image {
  width: min(100%, 760px);
  height: auto;
  display: block;
}

.auth-panel {
  width: min(100%, 700px);
  padding: 24px 22px 20px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(14px);
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
}

.auth-back-link {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.auth-panel__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
}

.auth-panel__logo {
  width: 104px;
  height: auto;
  display: block;
  flex-shrink: 0;
}

.auth-panel__brand-copy {
  display: flex;
  flex-direction: column;
}

.auth-panel__brand-title {
  color: #111827;
  font-size: 18px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.auth-panel__brand-subtitle {
  margin-top: 3px;
  color: #9ca3af;
  font-size: 12px;
}

.auth-panel__header {
  margin-top: 28px;
  text-align: center;
}

.auth-panel__title {
  margin: 0;
  color: #111111;
  font-size: clamp(24px, 3.3vw, 36px);
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.05em;
}

.auth-form {
  width: min(100%, 520px);
  margin: 24px auto 0;
}

.auth-form__row {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(209, 213, 219, 0.9);
  background: #ffffff;
}

.auth-form__label {
  padding: 14px 8px 8px;
  color: #c4c7cc;
  font-size: 14px;
  font-weight: 600;
}

.auth-form__input {
  height: 42px;
  padding: 0 8px 8px;
  border: 0;
  background: #ffffff;
  color: #111827;
  font-size: 16px;
  outline: none;
}

.auth-form__input:-webkit-autofill,
.auth-form__input:-webkit-autofill:hover,
.auth-form__input:-webkit-autofill:focus,
.auth-form__input:-webkit-autofill:active {
  -webkit-text-fill-color: #111827;
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  box-shadow: 0 0 0 1000px #ffffff inset;
  transition: background-color 9999s ease-out 0s;
}

.auth-form__input::placeholder {
  color: #d1d5db;
}

.auth-submit {
  width: 100%;
  height: 52px;
  margin-top: 6px;
  background: #334155;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.auth-panel__links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-top: 20px;
  color: #111111;
  flex-wrap: wrap;
}

.auth-panel__link {
  color: #111111;
  font-size: 14px;
  font-weight: 500;
}

.auth-panel__link--accent {
  font-weight: 700;
}

.auth-panel__divider {
  width: 1px;
  height: 26px;
  background: rgba(209, 213, 219, 0.9);
}

@media (max-width: 960px) {
  .auth-shell {
    padding: 20px 16px 28px;
  }
  .auth-shell__inner {
    padding: 20px 16px 28px;
  }
  .auth-panel {
    padding: 22px 18px 20px;
  }
  .auth-panel__header {
    margin-top: 24px;
  }
}
@media (max-width: 640px) {
  .auth-shell {
    padding: 16px 14px 24px;
  }
  .auth-shell__inner {
    padding: 16px 14px 24px;
  }
  .auth-panel__brand {
    align-items: flex-start;
  }
  .auth-panel__logo {
    width: 86px;
  }
  .auth-form {
    width: 100%;
    margin-top: 22px;
  }
  .auth-form__label {
    padding-top: 14px;
    font-size: 14px;
  }
  .auth-form__input {
    height: 40px;
    font-size: 15px;
  }
  .auth-submit {
    height: 48px;
    font-size: 16px;
  }
  .auth-panel__links {
    gap: 14px;
  }
  .auth-panel__link {
    font-size: 14px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public viewMode: 'landing' | 'login' = 'landing';
    public isTransitioning: boolean = true;

    public data: any = {
        username: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/dashboard";

        const params = new URLSearchParams(window.location.search);
        this.viewMode = params.get('mode') === 'login' ? 'login' : 'landing';
        await this.service.render();

        window.setTimeout(async () => {
            this.isTransitioning = false;
            await this.service.render();
        }, 480);
    }

    public async setViewMode(mode: 'landing' | 'login') {
        if (this.isTransitioning) return;
        this.isTransitioning = true;
        await this.service.render();

        window.setTimeout(async () => {
            this.viewMode = mode;
            const nextUrl = mode === 'login' ? '/access?mode=login' : '/access';
            window.history.replaceState({}, '', nextUrl);
            await this.service.render();

            window.setTimeout(async () => {
                this.isTransitioning = false;
                await this.service.render();
            }, 320);
        }, 240);
    }

    public async goToSignup() {
        if (this.isTransitioning) return;
        this.isTransitioning = true;
        await this.service.render();

        window.setTimeout(() => {
            location.href = '/signup';
        }, 300);
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            this.isTransitioning = true;
            await this.service.render();
            window.setTimeout(() => {
                location.href = "/dashboard";
            }, 300);
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;